/* global responsiveBackground */

import { Controller } from 'stimulus';

const ANIMATION_TIME = 500;
const TIMEOUT_TIME = 1000;

class HeroController extends Controller {
  connect() {
    let timeout;

    $(this.buttonTargets).each((i, button) => {
      $(button).on('mouseenter', (e) => {
        if (typeof timeout !== 'undefined') {
          clearTimeout(timeout);
        }

        const $backgroundType = $(e.currentTarget).data('background-type');
        this.changeBackground($backgroundType);
      });

      $(button).on('mouseleave', () => {
        timeout = setTimeout(() => {
          this.changeBackground('default');
        }, TIMEOUT_TIME);
      });
    });
  }

  changeBackground(backgroundType) {
    const $backgroundImage = $(this.backgroundTarget).data('bg');

    $(this.backgroundTarget).fadeOut(ANIMATION_TIME, () => {
      $(this.backgroundTarget).attr('data-bg', $backgroundImage.replace(/default/g, backgroundType));
      responsiveBackground();
      $(this.backgroundTarget).fadeIn(ANIMATION_TIME);
    });
  }
}

HeroController.targets = [
  'background',
  'button',
];

export default HeroController;
